import { FC, useState } from "react";
import { getTicketErrorMessage } from "entities/support-ticket";
import { formStyles } from "shared/ui";
import { useCloseTicketMutation } from "../api/closeTicketApi";

import styles from "./CloseTicketButton.module.css";

interface Props {
  ticketId: number;
}

// Закрытие необратимо, поэтому сначала спрашиваем подтверждение.
export const CloseTicketButton: FC<Props> = ({ ticketId }) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const [closeTicket, { isLoading, error }] = useCloseTicketMutation();
  const errorMessage = getTicketErrorMessage(error);
  const buttonClass = `${formStyles.outlineButton} ${formStyles.danger}`;

  if (!isConfirming) {
    return (
      <button
        type="button"
        className={`${buttonClass} ${styles.closeBtn}`}
        onClick={() => setIsConfirming(true)}
      >
        Close request
      </button>
    );
  }

  return (
    <div className={styles.confirm}>
      <span className={styles.question}>Close this request?</span>
      <button
        type="button"
        className={formStyles.outlineButton}
        disabled={isLoading}
        onClick={() => setIsConfirming(false)}
      >
        Cancel
      </button>
      <button
        type="button"
        className={buttonClass}
        disabled={isLoading}
        onClick={() => closeTicket(ticketId)}
      >
        {isLoading ? "Closing..." : "Close"}
      </button>
      {errorMessage && <p className={formStyles.error}>{errorMessage}</p>}
    </div>
  );
};
